import { Outlet } from "react-router-dom";

const GrievanceLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default GrievanceLayout;
